import { motion } from 'framer-motion'
import { ScrollReveal } from '@/components/shared/ScrollReveal'
import { toolkitGroups } from '@/content/portfolio'
import { useReducedMotion } from '@/lib/useReducedMotion'

export function Toolkit() {
  const reducedMotion = useReducedMotion()

  return (
    <section id="toolkit" className="relative isolate overflow-hidden border-t border-vibe-border bg-vibe-elevated py-16 lg:py-24">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-80 opacity-40 blur-3xl"
        style={{ background: 'radial-gradient(ellipse at 50% 0%, rgb(var(--accent) / 0.25), transparent 65%)' }}
      />
      <div className="mx-auto max-w-6xl px-4 lg:px-8">
        <ScrollReveal>
          <div className="text-center">
            <div className="section-label mb-3">Working stack</div>
            <h2 className="font-sans text-3xl font-semibold tracking-tight text-text-heading lg:text-5xl">
              My tech stack for product work
            </h2>
            <p className="mt-4 text-base text-text-secondary lg:text-lg">
              {toolkitGroups.reduce((total, group) => total + group.tools.length, 0)} tools I use to build, research, and design
            </p>
          </div>
        </ScrollReveal>

        <div className="mt-10 grid items-start gap-5 md:grid-cols-2">
          {[toolkitGroups.slice(0, 2), toolkitGroups.slice(2)].map((column, columnIndex) => (
            <div key={columnIndex} className="space-y-5">
              {column.map((group) => (
                  <article key={group.category} className="rounded-3xl border border-vibe-border bg-card-bg p-6 lg:p-7">
                    <h3 className="font-sans text-2xl font-semibold tracking-tight text-accent-primary lg:text-3xl">
                      {group.category}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-text-secondary lg:text-base">
                      {group.description}
                    </p>
                    <ul className="mt-7 space-y-5">
                      {group.tools.map((tool, index) => (
                        <li key={tool.name} className="flex items-center gap-4">
                          <motion.div
                            initial={reducedMotion ? false : { opacity: 0, y: 12, scale: 0.96 }}
                            animate={reducedMotion ? { opacity: 1, y: 0, scale: 1 } : undefined}
                            whileInView={{ opacity: 1, y: 0, scale: 1 }}
                            viewport={{ once: true, amount: 0.6 }}
                            transition={{ duration: reducedMotion ? 0 : 0.4, delay: reducedMotion ? 0 : index * 0.065, ease: [0.25, 0.1, 0.25, 1] }}
                            className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white p-2"
                          >
                            <img
                              src={tool.logo}
                              alt=""
                              loading="lazy"
                              className="h-full w-full object-contain"
                            />
                          </motion.div>
                          <div className="min-w-0">
                            <h4 className="font-sans text-lg font-semibold text-text-heading lg:text-xl">{tool.name}</h4>
                            <p className="mt-0.5 text-sm leading-relaxed text-text-secondary">{tool.use}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </article>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
